import React, { useState } from 'react';
import { useAppSelector } from 'src/app/redux/createAction';
import s from 'src/entities/Menu/ui/Nav/Nav.module.scss';
import { NavItem, SetActiveMenuItem } from 'src/entities/Menu/ui/NavItem/NavItem';
import MenuSVG from 'src/shared/assets/svg/menu.svg';
import { Icon } from 'src/shared/ui/Icon';

interface Props {
	onMenuClick: SetActiveMenuItem;
}

export const Nav: React.FC<Props> = (props) => {
	const { onMenuClick } = props;

	const [menuOpen, setMenuOpen] = useState(true);

	// * Selector
	const menuItems = useAppSelector((state) => state.company.menuItems);
	const activeMenuName = useAppSelector((state) => state.company.activeMenu);

	// * Render
	return (
		<div className={s.container}>
			<Icon
				className={s.icon}
				svg={<MenuSVG />}
				size={1}
				onClick={() => setMenuOpen(!menuOpen)}
			/>

			<div className={s.menuItems}>
				{menuOpen &&
					menuItems.map(({ name, value, totalValue }, index) => (
						<NavItem
							data-test={'menu_item_' + index.toString()}
							key={index}
							index={index}
							name={name}
							value={value}
							totalValue={totalValue}
							activeMenuItem={activeMenuName}
							onClick={onMenuClick}
						/>
					))}
			</div>
		</div>
	);
};
